import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next, useTranslation as useI18NextTranslation } from 'react-i18next';
import i18nextBackend from 'i18next-http-backend';
import { useTranslation as useBlanketTranslation } from '@wappsto/blanket';
import { SUPPORTED_LNGS } from 'configuration';

import 'dayjs/locale/bg';
import 'dayjs/locale/ca';
import 'dayjs/locale/cs';
import 'dayjs/locale/da';
import 'dayjs/locale/de';
import 'dayjs/locale/el';
import 'dayjs/locale/es';
import 'dayjs/locale/et';
import 'dayjs/locale/fi';
import 'dayjs/locale/fr';
import 'dayjs/locale/hr';
import 'dayjs/locale/hu';
import 'dayjs/locale/it';
import 'dayjs/locale/lt';
import 'dayjs/locale/lv';
import 'dayjs/locale/mk';
import 'dayjs/locale/nl';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/ro';
import 'dayjs/locale/sk';
import 'dayjs/locale/sl';
import 'dayjs/locale/sr';
import 'dayjs/locale/sv';

const match = window.location.pathname.match(/^\/\d{1,3}\.\d{1,3}/);
let loadPath = `/locales/{{lng}}/{{ns}}.json?version=${process.env.REACT_APP_VERSION}`;
if (match) {
  loadPath = match[0] + loadPath;
}
const missingTranslations: Record<string, Record<string, any>> = {};

i18n
  .use(LanguageDetector)
  .use(i18nextBackend)
  .use(initReactI18next)
  .init({
    // i18next-browser-languagedetector
    detection: {
      caches: ['cookie'],
      convertDetectedLanguage: (lng) => lng.replace('-', '_'),
    },

    // i18next-http-backend
    load: 'languageOnly',
    backend: {
      loadPath,
    },

    // i18next
    fallbackLng: 'en',
    debug: false,
    supportedLngs: SUPPORTED_LNGS,
    ns: [
      'subscriptions',
      'log',
      'error',
      'dataModel',
      'features',
      'components',
      'pages',
      'dashboards',
      'widgets',
    ],
    interpolation: {
      escapeValue: false,
    },
    saveMissing: true,
    appendNamespaceToMissingKey: true,

    missingKeyHandler(lngs, ns, key) {
      if (process.env.NODE_ENV !== 'development') return;

      for (let lng of lngs) {
        if (!missingTranslations[lng]) missingTranslations[lng] = {};
        missingTranslations[lng][`${ns}:${key}`] = true;
        console.error(`MISSING TRANSLATION `, missingTranslations);
      }
    },
  });

function useTranslation(ns?: string, keyPrefix?: string) {
  const { t } = useI18NextTranslation(ns, { keyPrefix });
  const { tC, tCE, tU } = useBlanketTranslation(t);

  return { t, tC, tCE, tU };
}

export { useTranslation, i18n };
